<template>
  <footer v-if="showFooter" id="base-footer">
    <div class="base-footer-top">
      <div style="flex-wrap: wrap-reverse">
        <div class="bf-copyright text-container">
          Copyright &copy; {{ copyDate }} {{ tenantName }} &nbsp;&nbsp;|&nbsp;&nbsp;All
          Rights Reserved.&nbsp;&nbsp;|&nbsp;&nbsp;<a
            :href="hpUrl + '/agreements/terms-of-use/'"
            target="_blank"
            >Terms of Use</a
          >&nbsp;&nbsp;|&nbsp;&nbsp;<a
            :href="hpUrl + '/agreements/privacy-policy/'"
            target="_blank"
            >Privacy Policy</a
          ><br />{{ address }}<br />{{ contactNumber }}
        </div>
      </div>
    </div>
    <div class="base-footer-mid">
      <div class="w-100">
        <div class="d-flex justify-content-center">
          <div
            class="marketplace-widget-container d-flex flex-wrap justify-content-between align-items-center mb-6 px-5"
          >
            <div>
              <TrustpilotWidget
                :width="trustpilotSizes.width"
                :height="trustpilotSizes.height"
              />
            </div>
            <div class="signal mx-5">
              <span class="icon-30-verified"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="base-footer-legal">
      California loans made pursuant to the California Financing Law, Division 9
      (commencing with Section 22000) of the Finance Code. All such loans made
      through {{ californiaDisclaimerLegalName }}
      and a licensed finance lender/broker, California Financing Law License No.
      {{ californiaFinancingLawNumber }}.
    </div>
  </footer>
</template>

<script>
import env from '~/libs/env'
import { phone } from '~/libs/format'
import { mapState } from 'pinia'
import {useCobrandStore} from '~/store/cobrand'
import TrustpilotWidget from '/components/TrustpilotWidget.vue'
import capitalize from 'lodash/capitalize'

export default {
  name: 'AppFooter',
  components: {
    TrustpilotWidget
  },
  props: {
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    hpUrl: env('hpBaseUrl'),
    copyDate: new Date().getFullYear(),
    tenantName: env('tenantName') ? capitalize(env('tenantName')) : 'Lendio',
    californiaDisclaimerLegalName: env('californiaDisclaimerLegalName'),
    californiaFinancingLawNumber: env('californiaFinancingLawNumber'),
  }),
  computed: {
    ...mapState(useCobrandStore, ['cobrand', 'loaded']),
    contactNumber() {
      return phone(
        this.cobrand
          ? this.cobrand.csPhone || env('generalContactNumber')
          : env('generalContactNumber')
      )
    },
    address() {
      return this.cobrand ? this.cobrand.address || env('address') : env('address')
    },
    trustpilotSizes() {
      return { height: 90, width: 140 }
    }
  }
}
</script>

<style lang="scss" scoped>
#base-footer {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  margin-top: 0;
  margin-left: 0;
  background-color: #f6f9fe;
  text-align: center;
  padding-top: 20px;

  .base-footer-top,
  .vue-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  .base-footer-mid {
    padding-bottom: 20px;
  }

  a:visited {
    color: #1a1331;
  }
  a:hover {
    color: #1a1331;
  }
  a:link {
    color: #1a1331;
    text-decoration: none;
  }
  a {
    transition: color 0.2s ease;
  }
  .base-footer-top {
    margin: 0 auto;
    padding: 10px;
  }

  .text-container {
    padding: 10px;
  }
  .bf-copyright {
    max-width: 530px;
    position: relative;
    display: inline-block;
    font-size: 14px;
    font-family: proxima-bold, Arial, sans-serif;
  }

  .base-footer-legal {
    max-width: 800px;
    position: relative;
    display: inline-block;
    color: #9ca5b0;
    font-size: 13px;
    padding-bottom: 30px;
  }
  .signal {
    padding: 5px 15px 5px 0;
    display: inline-block;
    vertical-align: middle;
  }
  .icon-30-verified {
    display: inline-block;
    background-image: url('~/public/images/sprite@2x.png');
    background-repeat: no-repeat;
    width: 122px;
    height: 30px;
    background-position: -1682px -106px;
    background-size: 2025px 136px;
  }
  .powered-by-trustpilot {
    color: #ccc;
    font-size: 10px;
    text-align: center;
  }
  .powered-by-trustpilot > img {
    width: 74px;
    height: 9px;
  }
}

/* END Base Footer */
</style>
